import React, { Component, lazy, Suspense } from 'react';
import { getUA } from 'react-device-detect';

import './App.css';

const Main = lazy(() => import('./Main'));

export default class App extends Component {
    render() {
        const message = 'Loading dailyme TV\u2026';
        const loading =
            <div className='loading'>
                <div className='message'>
                    {message}
                </div>
            </div>;
        return (
            <Suspense fallback={loading}>
                <Main />
            </Suspense>
        );
    }

    static isBot() {
        if (/APIs-Google|AdsBot-Google|Googlebot|Mediapartners-Google|FeedFetcher-Google|Google-Read-Aloud|Prerender/.test(getUA)) {
            return true;
        }
        return false;
    }

    static version() {
        return '1.6.0';
    }
}
